import { render, staticRenderFns } from "./DTotal.vue?vue&type=template&id=c0e7dfee&scoped=true"
import script from "./DTotal.vue?vue&type=script&lang=ts"
export * from "./DTotal.vue?vue&type=script&lang=ts"
import style0 from "./DTotal.vue?vue&type=style&index=0&id=c0e7dfee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e7dfee",
  null
  
)

export default component.exports